import axios from "axios";
// Google OAuth login/register
export const googleOAuthLogin = (code) =>
  api.post("login/oauth2/code/google", { code });

const api = axios.create({
  baseURL: "https://digitalmenu-psm5.onrender.com/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

export const postRequest = (endpoint, data, config = {}) =>
  api.post(endpoint, data, config);

export default api;
